import React from "react";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import { Label } from "../Label";

import "./index.scss";

export interface PhoneInputProps {
  labelTitle?: string;
  labelClassName?: string;
  disabled: boolean;
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  onBlur?(event: React.FocusEvent<HTMLInputElement>): void;
}

const PhoneInput: React.FC<PhoneInputProps> = (props) => {
  const { labelTitle, labelClassName, disabled, value, placeholder, onChange, onBlur } = props;

  return (
    <div className="phone-input">
      {labelTitle ? <Label title={labelTitle} className={labelClassName} /> : null}
      <ReactPhoneInput
        country={"us"}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        placeholder={placeholder}
      />
    </div>
  );
};

export default PhoneInput;
